<template>
  <li class="m-nav__item m-topbar__notifications m-topbar__notifications--img m-dropdown m-dropdown--large m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-right 	m-dropdown--mobile-full-width" data-dropdown-toggle="click" data-dropdown-persistent="true">
    <a href="" id="notify" class="m-nav__link m-dropdown__toggle" @click="changeNotificationsState(getNotifications)">
			<span id="point" v-if="getNews > 0" class="m-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger"></span>
			<span class="m-nav__link-icon">
        <span class="m-nav__link-icon-wrapper">
          <i class="flaticon-music-2 notification-i"></i>
        </span>
			</span>
		</a>

    <div class="m-dropdown__wrapper">
      <span class="m-dropdown__arrow m-dropdown__arrow--right"></span>
      <div class="m-dropdown__inner">
        <div class="m-dropdown__header m--align-center" style="background: url(assets/app/media/img/misc/notification_bg.jpg); background-size: cover;">
          <span class="m-dropdown__header-title">
            {{ 'notifications' | capitalize }}
          </span>
          <span class="m-dropdown__header-subtitle">
            {{ $i18n.tc('new_notification',getNews,{num: getNews}) | capitalize }}
					</span>
        </div>
        <div class="m-dropdown__body">
          <div class="m-dropdown__content">
            <div class="tab-content">
              <div class="tab-pane active" id="topbar_notifications_notifications" role="tabpanel">
                <div class="m-scrollable" data-scrollable="true" data-max-height="250" data-mobile-max-height="200">
                  <div class="m-list-timeline m-list-timeline--skin-light">
                    <div class="m-list-timeline__items" v-if="getNotifications.length > 0">
                      <div  v-for="(notification,index) in getNotifications" :key="index" class="m-list-timeline__item">
                        <span class="m-list-timeline__badge -m-list-timeline__badge--state-success"></span>
                        <template v-if="notification.open_message">
                          <span :class="notification.route  === '' ? 'm-list-timeline__text text-nowrap' : 'm-list-timeline__text cursor-pointer text-nowrap'" >
                            <a @click="openModal(index, notification.route)" >{{notification.content}}</a>
                          </span>
                          <span class="m-list-timeline__time">
                            {{ notification.created_date | subDates | capitalize }}
                          </span>
                          <span class="m-list-timeline__icon text-right">
                            <a @click="deleteNotification({id: notification.id, index: index})" class="cursor-pointer btn_notify_delete">
                              <i class="fa fa-trash"></i>
                            </a>
                          </span>
                        </template>
                        <template v-else>
                          <span class="m-list-timeline__text" >
                            <span class="m-list-timeline__time w-100 text-left">
                              {{ notification.created_date | subDates | capitalize }}
                            </span>
                            <span class="m-list-timeline__icon">
                              <a @click="deleteNotification({id: notification.id, index: index})" class="cursor-pointer btn_notify_delete">
                                <i class="fa fa-trash"></i>
                              </a>
                            </span>
                            <div :class="notification.route  === '' ? '' : 'cursor-pointer'">
                              <a @click="openModal(index, notification.route)" >{{ notification.content }}</a>
                            </div>
                            <div class="m-separator mb-2"></div>
                          </span>
                        </template>
                      </div>
                    </div>
                    <div class="m--align-center btn_notify_delete" v-else>
                        <span>{{ 'no_notifications_text' | capitalize }}</span>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
let cable = null
export default {
  computed: {
    ...mapGetters(['getNotifications', 'getUserData', 'getNews'])
  },
  methods: {
    ...mapMutations(['setNotifications', 'setNews', 'addNew']),
    ...mapActions(['updateNotifications', 'createNotification', 'deleteNotification', 'changeNotificationsState']),
    openModal (index, route) {
      if (route !== '') {
        this.$router.push({ name: route })
      }
      this.$store.commit('setNotificationOpen', index)
    },
    refresh: function () {
      if (Object.keys(this.getUserData).length > 0) {
        this.updateNotifications(this.getUserData.id).then((response) => {
          if (response.data.status === 200) {
            this.setNotifications(response.data.content.records)
            this.setNews(0)
            response.data.content.records.forEach(element => {
              if (element.state === 1) {
                this.addNew()
              }
            })
          }
        })
      }
    },
    execute_cable () {
      const self = this
      if (cable !== null) {
        cable.disconnect()
      }
      var cable_port = '3334'
      var location = window.location.href.split('/')[2].split(':')[0]
      var url = `ws://${location}:${cable_port}/cable`
      cable = ActionCable.createConsumer(url)
      cable.subscriptions.create(
        'NotificationsChannel',
        {
          connected: function () {

          },
          disconnected: function () {

          },
          received: function (data) {
            self.refresh()
          }
        }
      )
    }
  },
  created () {
    this.refresh()
    this.execute_cable()
  }
}
</script>

<style scoped>
#point {
  height: 8px !important;
  width: 8px !important;
  margin-left: -4px !important;
  background-color: #F6A917;
}
</style>




// WEBPACK FOOTER //
// Notifications.vue